module.exports = __webpack_public_path__ + "img/eleiko2.788398fd.png";